// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsMenu-cls1_H1V","cls2":"ToolsMenu-cls2_1uO ToolsMenu-cls1_H1V"};